const mEditionAcademyInvitationsModalCreate = {
  mEditionAcademyInvitationsModalCreate: {
    buttonCancel: 'CANCELAR',

    buttonPrimary: 'ENVIAR',

    inputs: {
      actor: {
        label: 'Rol de Nuevo Usuario'
      },

      email: {
        label: 'Email de Invitación',
        placeholder: 'usuario@email.com'
      }
    },

    title: 'Enviar Invitación'
  }
}

export default mEditionAcademyInvitationsModalCreate
